module.exports = __webpack_public_path__ + "img/mb-alert.885961a5.png";